import React from "react";
import CtaSection from "../../components/Common/CtaSection";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import Footer from "../../components/Layout/Footer";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import shapeImageUrl from "../../assets/images/shapes/cta-one-shape-1.png";

const TermsConditionsMain = () => {
  return (
    <React.Fragment>
      {/*Page Header*/}
      <SiteBreadcrumb
        pageTitle="Terms & Conditions"
        parentCategory="Home"
        pageCategory="Legal"
        pageName="Terms & Conditions"
        breadcrumbsImg={bannerbg}
      />

      {/*Terms & Conditions Section Start*/}
      <section className="terms-conditions-one">
        <div className="container">
          <div className="terms-conditions-content">
            {/* 1. Introduction */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">1. Introduction</h3>
              <p>
                Welcome to Arch Elevators Pvt. Ltd. ("Company," "we," "us," or "our"). These Terms & Conditions ("Terms") 
                govern your access to and use of our website, products, and services. By accessing or using our website and services, 
                you agree to be bound by these Terms. If you do not agree with any part of these Terms, please do not use our services.
              </p>
            </div>

            {/* 2. Company Information */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">2. Company Information</h3>
              <p>
                <strong>Company Name:</strong> Arch Elevators Pvt. Ltd. <br />
                <strong>Registered Address:</strong> 305-4TH Floor, Silver Cross Building, Satellite, Ahmedabad 380015, India <br />
                <strong>Contact Email:</strong> info@archelevators.com <br />
                <strong>Contact Phone:</strong> +91 90332 26011
              </p>
            </div>

            {/* 3. Use License */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">3. Use License</h3>
              <p>
                We grant you a limited, non-exclusive, non-transferable license to access and use our website and services for lawful purposes only. 
                You agree not to:
              </p>
              <ul className="terms-list">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon intellectual property rights</li>
                <li>Transmit any harmful, malicious, or unauthorized code</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Engage in any form of harassment or abusive behavior</li>
                <li>Use the website for commercial purposes without permission</li>
              </ul>
            </div>

            {/* 4. Product & Service Information */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">4. Product & Service Information</h3>
              <p>
                Arch Elevators manufactures and provides elevator solutions including:
              </p>
              <ul className="terms-list">
                <li>Passenger elevators</li>
                <li>Freight elevators</li>
                <li>Circular elevators (India's exclusive manufacturer)</li>
                <li>Maintenance and support services</li>
                <li>Technical support and consultation</li>
              </ul>
              <p>
                All product specifications, pricing, and availability are subject to change without notice. 
                We reserve the right to discontinue any product or service at any time.
              </p>
            </div>

            {/* 5. Pricing & Payment */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">5. Pricing & Payment Terms</h3>
              <p>
                <strong>Quotations:</strong> All quotes provided by Arch Elevators are subject to confirmation and are valid for 30 days unless otherwise stated. <br />
                <strong>Payment Terms:</strong> Payment must be made as per the terms agreed upon in the purchase order or contract. <br />
                <strong>Currency:</strong> All prices are in Indian Rupees (INR) unless otherwise specified. <br />
                <strong>Taxes:</strong> All applicable taxes, GST, and other levies shall be borne by the client as per Indian law.
              </p>
            </div>

            {/* Delivery & Installation removed for informational site */}

            {/* 7. Warranty & Maintenance */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">7. Warranty & Maintenance</h3>
              <p>
                <strong>Standard Warranty:</strong> All products come with a standard warranty period of 12 months from the date of purchase or as otherwise stated, 
                covering manufacturing defects. <br />
                <strong>Warranty Exclusions:</strong> Warranty does not cover damage due to misuse, improper maintenance, accidents, or normal wear and tear. <br />
                <strong>Preventive Maintenance:</strong> We recommend regular maintenance contracts to ensure optimal performance and safety compliance. <br />
                <strong>Service Charges:</strong> Any maintenance or repair services beyond the warranty period will be charged separately.
              </p>
            </div>

            {/* 8. Intellectual Property */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">8. Intellectual Property Rights</h3>
              <p>
                All content on our website, including but not limited to text, images, graphics, logos, and designs, is the property of 
                Arch Elevators Pvt. Ltd. or its content providers. You are prohibited from reproducing, distributing, or transmitting any 
                content without our prior written permission.
              </p>
            </div>

            {/* 9. Limitation of Liability */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">9. Limitation of Liability</h3>
              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, ARCH ELEVATORS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, 
                CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF OUR PRODUCTS OR SERVICES, EVEN IF ADVISED 
                OF THE POSSIBILITY OF SUCH DAMAGES.
              </p>
            </div>

            {/* 10. Indemnification */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">10. Indemnification</h3>
              <p>
                You agree to indemnify and hold harmless Arch Elevators Pvt. Ltd., its officers, employees, and agents from any claims, 
                damages, losses, or expenses (including legal fees) arising from your violation of these Terms or your misuse of our products 
                and services.
              </p>
            </div>

            {/* 11. Compliance & Safety */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">11. Compliance & Safety Standards</h3>
              <p>
                All Arch Elevators products comply with Indian Standards (IS 4501-1992) and relevant safety regulations. 
                Where applicable, clients should ensure that the building structure meets load-bearing requirements and that all local 
                regulatory approvals are obtained.
              </p>
            </div>

            {/* 12. Dispute Resolution */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">12. Dispute Resolution</h3>
              <p>
                Any disputes arising from these Terms or the use of our products and services shall be governed by Indian law. 
                The parties agree to attempt resolution through negotiation. If negotiation fails, disputes shall be referred to 
                arbitration under the Arbitration and Conciliation Act, 1996, with the seat of arbitration being Ahmedabad, Gujarat.
              </p>
            </div>

            {/* 13. Privacy & Data Protection */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">13. Privacy & Data Protection</h3>
              <p>
                We collect and process personal information in accordance with applicable data protection laws. 
                Your data will be used only for purposes related to our business operations and will not be shared with third parties 
                without your consent, except as required by law.
              </p>
            </div>

            {/* 14. Modifications to Terms */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">14. Modifications to Terms</h3>
              <p>
                Arch Elevators reserves the right to modify these Terms & Conditions at any time. Changes will be effective immediately 
                upon posting to the website. Your continued use of our services indicates your acceptance of the updated Terms.
              </p>
            </div>

            {/* 15. Termination */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">15. Termination</h3>
              <p>
                We reserve the right to terminate or restrict your access to our website and services at any time, with or without cause, 
                if we believe you have violated these Terms or engaged in unlawful activity.
              </p>
            </div>

            {/* 16. Contact Information */}
            <div className="terms-conditions-item">
              <h3 className="terms-conditions-title">16. Contact Us</h3>
              <p>
                For any questions or concerns regarding these Terms & Conditions, please contact us at: <br />
                <strong>Email:</strong> info@archelevators.com <br />
                <strong>Phone:</strong> +91 90332 26011 <br />
                <strong>Address:</strong> 305-4TH Floor, Silver Cross Building, Satellite, Ahmedabad 380015, India
              </p>
            </div>

            {/* Last Updated */}
            <div className="terms-conditions-item" style={{ marginTop: "40px", borderTop: "1px solid #e0e0e0", paddingTop: "20px" }}>
              <p style={{ fontSize: "14px", color: "#666" }}>
                <strong>Last Updated:</strong> December 2025
              </p>
            </div>
          </div>
        </div>
      </section>
      {/*Terms & Conditions Section End*/}

      {/*CTA Section*/}
      <CtaSection
        title="Need More Information?"
        text="Call us today for any queries"
        phoneNumber="+919033226011"
        breadcrumbsImg={bannerbg}
        shapeImageUrl={shapeImageUrl}
      />

      {/*Footer*/}
      <Footer />
    </React.Fragment>
  );
};

export default TermsConditionsMain;
